<template>
  <div>
    <!--    <div class="sessionList">-->
    <!--      <div v-for="(session_item,index) in sessionList" :key="index">-->
    <!--        <div @click="getSessionEvents(session_item.session_name)" class="session-item">-->
    <!--          <div style="margin-left: 45px;margin-top: 45px">-->
    <!--            <img src="../../../assets/icon_session_ungoing.png" style="width: 93px;height: auto">-->
    <!--          </div>-->
    <!--          <p class="session-name">{{ session_item.session_name }}</p>-->
    <!--          <div class="session-item-bottom">-->
    <!--            <div style="display: flex;flex-direction: row;align-items: center;position: absolute;bottom: 45px">-->
    <!--              <div style="display: flex;flex-direction: row;align-items: center">-->
    <!--                <img src="../../../assets/calender.png" style="width: 12px;height: auto">-->
    <!--                <p class="session-time" style="margin-left: 10px">{{ session_item.session_time }}</p>-->
    <!--                <img src="../../../assets/arrow.png" style="margin-left: 20px;width: 19px;height: 19px">-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div style="width:1100px;margin:40px auto">
      <div class="student-session-title">我的项目</div>
      <div class="session-title-1">MY EVENT</div>
      <div class="my-events">
        <div v-for="(item,index) in my_events" :key="index">
          <div class="events-item">
            <div style="position: absolute;z-index: 1">
              <img src="../../../assets/event_bg.png" style="width: 100%;height: 176px;">
            </div>
            <div style="z-index: 2;padding: 0px 36px ;">
              <div class="event_name">{{ item.name }}   <span class="type_label">{{item.type + ' Test'}}</span></div>
              <div style="position: relative;margin-top: 10px;height: 60px;display: flex;flex-direction: row">
                <div style="display: flex;flex-direction: row;align-items: center;">
                  <div style="font-family: Montserrat-SemiBold;color: #00348B;font-size: 18px;font-weight: 600">开始时间</div>
                  <div style="font-family: Montserrat-SemiBold;color: #00348B;font-size: 18px;font-weight: 600;margin-left: 10px">
                    {{ formatSessionDate(item.event_start_time) }}
                  </div>
                </div>
                <div
                    style="top: 50%;transform: translateY(-50%);display: flex;flex-direction: row;align-items: center;position: absolute;right: 0">
                  <div class="event-status">{{item.status}}</div>
                  <div class="event-entry" style="margin-left: 10px" @click="goExam(item)">进入考场</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="student-session-title">其它进行项目</div>
      <div class="session-title-1">OTHER ONGOING EVENTS</div>
      <div class="my-events">
        <div v-for="(item,index) in my_other_events" :key="index">
          <div class="events-item">
            <div style="position: absolute;z-index: 1">
              <img src="../../../assets/event_bg.png" style="width: 100%;height: 176px;">
            </div>
            <div style="z-index: 2;padding: 0px 36px ;">
              <div class="event_name">{{ item.name }}</div>
              <div style="position: relative;margin-top: 10px;height: 60px;display: flex;flex-direction: row">
                <div style="display: flex;flex-direction: row;align-items: center;">
                  <div style="font-family: Montserrat-SemiBold;color: #2D50B0;font-size: 18px;font-weight: 600">开始时间</div>
                  <div style="font-family: Montserrat-SemiBold;color: #F18601;font-size: 18px;font-weight: 600;margin-left: 10px">
                    {{ formatSessionDate(item.event_start_time) }}
                  </div>
                </div>
                <!--                <div-->
                <!--                    style="top: 50%;transform: translateY(-50%);display: flex;flex-direction: row;align-items: center;position: absolute;right: 0">-->
                <!--                  <div class="event-status">状态</div>-->
                <!--                  <div class="event-entry" style="margin-left: 10px">进入考场</div>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {checkIsUploadTest, getExerciseTestTemplate, getSessionEvents,checkUserInvigilate ,getExamReadyTime} from '../../../api/index'
import {getApplicationEvents, getApplicationExtraEvents,getProjectCode, getUserId,setTestEvent} from "../../../utils/store";
import {formatDate} from "../../../utils/date";
import '../../../assets/common/font.css'
export default {
  name: "SessionList",
  data() {
    return {
      project_code: '',
      my_events: [],
      my_other_events: [],
      sessionList: [],
      login_application_extra_events: [],
      login_application_events: [],
      exam_entry_before_time: 240 * 60 * 1000,
      exam_prohibit_time_when_start: 240 * 60 * 1000,
    }
  },
  mounted() {
    this.login_application_extra_events = getApplicationExtraEvents()
    this.login_application_events = getApplicationEvents()
    this.project_code = getProjectCode()
    this.fetchData()
    this.getReadyTime()

  },
  methods: {
    getReadyTime() {
      getExamReadyTime().then((res) => {
        let result = res && res.data && res.data.data;
        if (result && Number(result.exam_entry_before_time) > 0) {
          this.exam_entry_before_time = Number(result.exam_entry_before_time) * 60 * 1000;
        }
        if (result && Number(result.exam_prohibit_time_when_start) > 0) {
          this.exam_prohibit_time_when_start = Number(result.exam_prohibit_time_when_start) * 60 * 1000;
        }
      }).catch(() => {});
    },
    goExam(item) {
      var startTime = item.event_start_time
      var temp1 = parseInt(startTime) * 1000
      var endTime = parseInt(item.event_end_time) * 1000
      var currentTime = new Date().getTime()
      console.log('temp1 :' + temp1)
      console.log('endTime :' + endTime)
      console.log('currentTime :' + currentTime)
      var test_event = item.name
      if (item.type == 'Formal'){
        if (temp1 > currentTime) {
          this.$message({
            message: '考试开始时间未到，请再耐心等待一会',
            type: 'warning'
          })
          return
        }

        if (endTime && endTime < currentTime) {
          this.$message({
            message: '考试已结束，无法入场',
            type: 'warning'
          })
          return
        }
      }



      getExerciseTestTemplate(item.name, getProjectCode(),item.type,test_event).then((res) => {
        var result = res.data.data
        var template_id = result._id.$id
        this.doCheck(template_id,temp1,endTime,item.type,test_event)
      })
    },
    doCheck(template_id,timeStr,endTimeStr,event_type,test_event) {
      var student_id = getUserId()
      checkIsUploadTest(template_id, student_id).then((res) => {
        var result = res.data
        // result= false
        if (result) {
          this.$alert('您已经参加过此次考试，无需再进入考试，请知晓！', '提示', {
            confirmButtonText: '确定',
            callback: () => {
            }
          });
        } else {
          setTestEvent(test_event)

          //判断是否需要监考
          checkUserInvigilate(getProjectCode(),getUserId()).then((res) => {
            console.log(1111,res)
            //true 需要监考
            if (res.data == true){
              this.$router.push({
                path: '/ready/exam',
                query: {
                  template_id: template_id,
                  start_time:timeStr,
                  end_time:endTimeStr,
                  event_type:event_type
                }
              })
            }else{

              this.$router.push({
                path: "/exam",
                query: {
                  template_id: template_id,
                  invigilateStatus:true
                },
              });
            }
          })
          
        }
      })
    },
    formatSessionDate(time) {
      var time_1 = JSON.parse(time) * 1000;
      var date = new Date(time_1)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    },
    fetchData() {
      this.getSessionEvents('Economics')
      // getSessionList(this.project_code).then((res) => {
      //   var result = res.data.data
      //   var keys = Object.keys(result)
      //   for (var i = 0; i < keys.length; i++) {
      //     var key = keys[i]
      //     var session = {
      //       session_name: key,
      //       session_time: result[key]
      //     }
      //     this.sessionList.push(session)
      //   }
      //   var first_session_name = this.sessionList[0]['session_name']
      //   this.getSessionEvents(first_session_name)
      // })
    },
    getSessionEvents(session) {
      this.my_other_events = []
      this.my_events = []
      getSessionEvents(this.project_code, session,getUserId()).then((res) => {
        var result = res.data.data
        console.log(1111,this.login_application_events)

        var keys = Object.keys(result)

        for (var i = 0; i < keys.length; i++) {
          var key = keys[i]
      
          var details = result[key]

          for (var j = 0; j < details.length; j++) {
              this.my_events.push(details[j])
          }

        }

        // if (session == 'Economics') {
        //   this.my_events = result[session]
        // } else {
          // if (this.login_application_events) {
          //   for (var i = 0; i < this.login_application_events.length; i++) {
          //     var event = this.login_application_events[i]
          //     if (result[event]) {//有数据
          //       var temp = result[event]
          //       for (var m = 0; m < temp.length; m++) {
          //         this.my_events.push(temp[m])
          //       }
          //     }
          //   }
          // }
        // }

        if (this.login_application_extra_events) {
          for (var j = 0; j < this.login_application_extra_events.length; j++) {
            var event1 = this.login_application_extra_events[j]
            if (result[event1]) {//有数据
              var temp1 = result[event1]
              for (var n = 0; n < temp1.length; n++) {
                this.my_other_events.push(temp1[n])
              }
            }
          }
        }
      })
    }
  }
}
</script>


<style scoped>

.event-entry {
  font-family: Montserrat-SemiBold;
  cursor: pointer;
  padding: 2px 5px;
  font-weight: 600;
  font-size: 18px;
  color: #ffffff;
  background: #2A5AD9;
  border-radius: 5px;
  border: 2px solid #2A5AD9;
}

.event-status {
  font-weight: 600;
  font-size: 18px;
  padding: 2px 5px;
  color: #ffffff;
  background: #00D523;
  border-radius: 5px;
  border: 2px solid #00D523;
}

.event_name {
  font-family: Montserrat-SemiBold;
  font-size: 40px;
  font-weight: 900;
  color: #00348B;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.events-item {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  height: 176px;
  margin-right: 45px;
  margin-bottom: 30px;
}

.my-events {
  width: 100%;
  margin-top: 15px;
  margin-right: 45px;
}

.student-session-title {
  font-weight: 600;
  color: #00348B;
  font-size: 18px;
  font-family: Montserrat-SemiBold;
}

.session-title-1 {
  font-family: Montserrat-SemiBold;
  font-weight: 800;
  color: #00348B;
  font-size: 32px;
}

.session-name {
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin: 10px 0 0 45px;
  font-family: Montserrat-SemiBold;
}

.session-item {
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 340px;
  height: 285px;
  background-image: url("../../../assets/session_nav_bg.png");
  background-repeat: no-repeat;
  background-size: contain;
  background-color: transparent;
}

.session-item-bottom {
  position: relative;
  height: 110px;
  margin-top: 30px;
  padding-left: 45px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.session-time {
  margin: 0;
  padding: 0;
  font-size: 16px;
  color: #F18601;
  font-weight: 600;
  font-family: Montserrat-SemiBold;
}

.sessionList {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.type_label{
  font-size:18px;
  margin-left:10px;
}

</style>